var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patient-routine"},[_c('transition',{attrs:{"name":_vm.effect,"mode":"out-in"}},[(_vm.isOrderFilterShowing)?_c('orders-main-filter'):_c('patient-routine-view')],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }